import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=aca39a0a"
import script from "./Primary.vue?vue&type=script&lang=js"
export * from "./Primary.vue?vue&type=script&lang=js"
import style0 from "./Primary.vue?vue&type=style&index=0&id=aca39a0a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports